import { parseResponse, requestApi } from '~/services/api';
import REDUCER_NAME from './we-spin-reducer-name';
import enhanceImageView from '~/components/casino-shared/utilities/enhanceImage';
import { createImageViewFactory } from '~/components/utilities/image-format';

const ACTION_PREFIX = '@komigen/we-spin';
const host = '/';

export const FETCH_WESPIN_DESKTOP_GAMES_START = `${ACTION_PREFIX}/FETCH_DESKTOP_GAMES_START`;
export const FETCH_WESPIN_DESKTOP_GAMES_FINISH = `${ACTION_PREFIX}/FETCH_DESKTOP_GAMES_FINISH`;

const mapGamesToCodes = (games, { imageDescriptors, formatEnhancer }) =>
	games.reduce(
		(acc, game) => ({
			...acc,
			[game.code]: {
				...game,
				...(game.imageView && {
					imageView: enhanceImageView(game.imageView, imageDescriptors, formatEnhancer)
				})
			}
		}),
		{}
	);

const mapGamesToProviders = games => {
	const map = new Map();
	games.forEach(game => {
		const provider = map.get(game.provider.code);
		if (provider) {
			map.set(game.provider.code, { ...provider, gameCodes: [...provider.gameCodes, game.code] });
		} else {
			map.set(game.provider.code, { ...game.provider, gameCodes: [game.code] });
		}
	});
	return Object.fromEntries(map);
};

const fetchDesktopGames = () => {
	return async (dispatch, getState, { isPictureElementEnabled, imageDescriptors, imageFormats }) => {
		const state = getState();

		const formatEnhancer = isPictureElementEnabled && createImageViewFactory(imageFormats, imageDescriptors);

		const {
			[REDUCER_NAME]: {
				availableGames: { hydrated, loading }
			}
		} = state;

		if (hydrated || loading) {
			return;
		}

		dispatch({
			type: FETCH_WESPIN_DESKTOP_GAMES_START
		});

		const resourcePath = `rest/state/casino/games/v2?dummy=11`;

		const response = parseResponse(
			await requestApi(`${host}${resourcePath}`, {}, 'GET', false, false, {}, { cache: 'default' })
		);

		dispatch({
			type: FETCH_WESPIN_DESKTOP_GAMES_FINISH,
			payload: {
				gamesList: mapGamesToCodes(response, { imageDescriptors, formatEnhancer }),
				providers: mapGamesToProviders(response)
			}
		});
	};
};

export { fetchDesktopGames };
